import { render, staticRenderFns } from "./SummaryReportForContractsWithSimplification.vue?vue&type=template&id=64be7238&"
import script from "./SummaryReportForContractsWithSimplification.vue?vue&type=script&lang=js&"
export * from "./SummaryReportForContractsWithSimplification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports